"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var wf_permissions_helper_service_1 = require("../../service/wf-permissions-helper.service");
var idm_workflow_designer_1 = require("@synisys/idm-workflow-designer");
var workflow_designer_types_1 = require("@synisys/idm-workflow-designer/app/controls/shared/workflow-designer.types");
var notification_model_1 = require("../../model/notification-model");
var custom_metadata_model_1 = require("../model/custom-metadata-model");
var workflow_base_control_component_1 = require("../../workflow-base-control.component");
var WfProcessViewTwoLevelComponent = /** @class */ (function (_super) {
    __extends(WfProcessViewTwoLevelComponent, _super);
    function WfProcessViewTwoLevelComponent(currentLanguageProvider, classifierService, processService, kbService, helperService) {
        var _this = _super.call(this, currentLanguageProvider) || this;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.classifierService = classifierService;
        _this.processService = processService;
        _this.kbService = kbService;
        _this.helperService = helperService;
        // Public
        _this.firstClassifierLabel = 'cms_first_classifier';
        _this.secondClassifierLabel = 'cms_second_classifier';
        _this.close = new core_1.EventEmitter();
        _this._selectedFirstClassifierTabIndex = 0;
        _this._selectedSecondClassifierTabIndex = 0;
        _this._selectedFirstClassifierId = 0;
        _this._selectedSecondClassifierId = 0;
        _this._viewports = new Map();
        _this._notification = new notification_model_1.NotificationModel();
        _this._initialActions = [];
        _this._stateValues = [];
        return _this;
    }
    WfProcessViewTwoLevelComponent_1 = WfProcessViewTwoLevelComponent;
    WfProcessViewTwoLevelComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        var roles$ = this.helperService.getRoles(this.roleIds);
        var metaFields$ = this.kbService.getMetaFields(this.category);
        var conditionalPermissions$ = this.helperService.getCategoryConditionalPermissions(this.category);
        var matrix$ = this.helperService.getMatrix(this.category);
        var customLayoutMetadata$ = this.helperService.getCustomLayoutMetadata(this.category);
        var viewport$ = this.getProcessLayout(this.category);
        var firstClassifier$ = metaFields$.pipe(operators_1.switchMap(function (fields) {
            _this._firstClassifierCategory = fields.find(function (value) { return value.getSystemName() === _this.firstClassifierField; }).getCompoundCategorySystemName();
            return _this.classifierService.loadClassifiersView(_this._firstClassifierCategory);
        }));
        var secondClassifier$ = metaFields$.pipe(operators_1.switchMap(function (fields) {
            _this._secondClassifierCategory = fields.find(function (value) { return value.getSystemName() === _this.secondClassifierField; }).getCompoundCategorySystemName();
            return _this.kbService.getMetaFields(_this._secondClassifierCategory);
        }), operators_1.switchMap(function (secondClassifierFields) {
            var secondClassifierParentMetaField = secondClassifierFields.find(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.PARENT &&
                field.getCompoundCategorySystemName() === _this._firstClassifierCategory; });
            if (secondClassifierParentMetaField) {
                _this._isHierarchical = true;
                _this._secondClassifierParentMetaFieldId = secondClassifierParentMetaField.getMetaFieldId();
            }
            return _this.classifierService.loadAllClassifiers(_this._secondClassifierCategory);
        }), operators_1.map(function (value) { return value.getData(); }));
        Observable_1.Observable.zip(firstClassifier$, secondClassifier$, conditionalPermissions$, matrix$, viewport$, roles$, customLayoutMetadata$)
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function (data) {
            _this.rolesMap = WfProcessViewTwoLevelComponent_1.constructRolesMap(data[5]);
            _this._customizedLayoutsMetadata = data[6];
            _this.firstClassifiers = data[0];
            _this._secondClassifiers = _this._isHierarchical ?
                WfProcessViewTwoLevelComponent_1.prepareHierarchy(data[0], data[1], _this._secondClassifierParentMetaFieldId, _this.currentLanguageId) :
                WfProcessViewTwoLevelComponent_1.prepareNonHierarchy(data[0], data[1], _this.currentLanguageId);
            var permissions = WfProcessViewTwoLevelComponent_1.initPermissionOptions(_this.currentLanguageId, data[2]);
            _this._permissionsByCondition = WfProcessViewTwoLevelComponent_1.fromMatrix(data[3], permissions, _this.roleIds);
            _this._viewports = WfProcessViewTwoLevelComponent_1.constructViewportMap(_this._permissionsByCondition, data[4], data[6]);
            _this._selectedFirstClassifierId = _this.firstClassifiers[0].getId();
            _this._selectedSecondClassifierId = _this.secondClassifiers.get(_this._selectedFirstClassifierId)[0].getId();
            _this.initializationReady();
            _this.resetHideActions();
        });
    };
    WfProcessViewTwoLevelComponent.prototype.select = function (model, firstClassifierId, secondClassifierId) {
        if (model && model['type'] === workflow_designer_types_1.WorkflowDesignerType.ACTION) {
            this._selectedActionId = model.id;
            this._selectedActionRoles = this.getPermittedRoles(this.selectedActionId, firstClassifierId, secondClassifierId);
        }
        else {
            this._selectedActionId = undefined;
            this._selectedActionRoles = [];
        }
    };
    WfProcessViewTwoLevelComponent.prototype.saveChangedMetadata = function () {
        var _this = this;
        var index = this.customizedLayoutsMetadata
            .findIndex(function (metadata) { return metadata.firstClassifierId === _this.selectedFirstClassifierId && metadata.secondClassifierId === _this.selectedSecondClassifierId; });
        var newModel = new custom_metadata_model_1.CustomMetadataModel(this.selectedFirstClassifierId, this.selectedSecondClassifierId, this.viewports.get(this.selectedFirstClassifierId).get(this.selectedSecondClassifierId).getMetadata());
        if (index > -1) {
            this.customizedLayoutsMetadata[index] = newModel;
        }
        else {
            this.customizedLayoutsMetadata.push(newModel);
        }
        if (!this.saveInProgress) {
            this.saveInProgress = true;
            this.helperService.saveCustomLayoutMetadata(this.category, this.customizedLayoutsMetadata)
                .pipe(operators_1.catchError(function (err) {
                return Observable_1.Observable.throw(err);
            }), operators_1.takeUntil(this.destroy$))
                .subscribe(function () {
                _this.showNotification('Success', 'cms_saved_successful');
            }, function (err) {
                _this.showNotification('Error', 'cms_error_saving_permissions_layout');
            });
        }
    };
    WfProcessViewTwoLevelComponent.prototype.handleSelectedStates = function (ids) {
        var _this = this;
        this._stateValues = ids;
        this.viewports.get(this.selectedFirstClassifierId).get(this.selectedSecondClassifierId).process.actions = this._initialActions
            .filter(function (action) { return (_this._stateValues.indexOf(action.end.id) < 0); });
    };
    WfProcessViewTwoLevelComponent.prototype.resetHideActions = function () {
        this._stateValues = [];
        this._initialActions = [];
        if (this.viewports.has(this.selectedFirstClassifierId) && this.viewports.get(this.selectedFirstClassifierId).has(this.selectedSecondClassifierId)) {
            this._initialActions = this.viewports.get(this.selectedFirstClassifierId).get(this.selectedSecondClassifierId).process.actions.slice();
        }
    };
    WfProcessViewTwoLevelComponent.prototype.getPermittedRoles = function (actionId, firstClassifierId, secondClassifierId) {
        var data = [];
        if (this._permissionsByCondition.has(firstClassifierId)) {
            if (this._permissionsByCondition.get(firstClassifierId).has(secondClassifierId)) {
                if (this._permissionsByCondition.get(firstClassifierId).get(secondClassifierId).has(actionId)) {
                    for (var _i = 0, _a = Array.from(this._permissionsByCondition.get(firstClassifierId).get(secondClassifierId).get(actionId).keys()); _i < _a.length; _i++) {
                        var roleId = _a[_i];
                        if (this.rolesMap.has(roleId)) {
                            var permission = this._permissionsByCondition.get(firstClassifierId).get(secondClassifierId).get(actionId).get(roleId);
                            data.push({
                                role: this.rolesMap.get(roleId).properties['name'],
                                permission: permission ? permission.name : ''
                            });
                        }
                    }
                }
            }
        }
        return data;
    };
    WfProcessViewTwoLevelComponent.prototype.getProcessLayout = function (category) {
        var _this = this;
        return Observable_1.Observable.fromPromise(this.processService.getProcesses()).pipe(operators_1.map(function (processes) { return processes.find(function (value) { return value.getCategorySystemName() === category; }).getId(); }), operators_1.switchMap(function (processId) { return Observable_1.Observable.fromPromise(_this.processService.getStructure(processId)); }), operators_1.map(function (process) {
            var viewport = new idm_workflow_designer_1.WorkflowDesignerViewportModel();
            viewport.viewMode = true;
            var startState = new idm_workflow_designer_1.WorkflowDesignerStateModel(0).setStart().position(40, 180, 120, 42);
            viewport.process.states.push(startState);
            process.getStates().forEach(function (state) {
                var viewportState = new idm_workflow_designer_1.WorkflowDesignerStateModel(state.getId(), state.getName(), state.getDescription()).setIsFinal(state.getIsFinal());
                viewport.process.states.push(viewportState);
            });
            if (process.getInitialStateIndex() !== null && viewport.process.states[process.getInitialStateIndex() + 1]) {
                viewport.process.actions.push(new idm_workflow_designer_1.WorkflowDesignerActionModel(0).linkStates(viewport.process.states[0], viewport.process.states[process.getInitialStateIndex() + 1]).setStart());
            }
            process.getActions().forEach(function (action) {
                viewport.process.actions.push(new idm_workflow_designer_1.WorkflowDesignerActionModel(action.getId(), action.getName(), action.getDescription()).linkStates(viewport.process.states[action.getInitialStateIndex() + 1], viewport.process.states[action.getTargetStateIndex() + 1]).setFormId(action.getFormId()));
            });
            viewport.setMetadata(process.getLayout());
            return viewport;
        }));
    };
    WfProcessViewTwoLevelComponent.fromMatrix = function (matrix, permissions, roleIds) {
        var data = new Map();
        var _loop_1 = function (i) {
            if (roleIds.indexOf(matrix[i][0]) === -1) {
                return "continue";
            }
            var roleId = matrix[i][0];
            var firstClassifierId = matrix[i][1];
            var secondClassifierId = matrix[i][2];
            var actionId = matrix[i][3];
            var isFull = (matrix[i][4] === 1);
            var isCustom = (matrix[i][4] === 2);
            var permissionKey = matrix[i][5];
            var permission = void 0;
            if (isFull) {
                permission = permissions.find(function (value) { return value.isFull; });
            }
            else if (isCustom) {
                permission = permissions.find(function (value) { return value.permissionKey === permissionKey; });
            }
            if (permission) {
                WfProcessViewTwoLevelComponent_1.preparePermissionByConditionMap(data, firstClassifierId, secondClassifierId, actionId);
                data.get(firstClassifierId).get(secondClassifierId).get(actionId).set(roleId, permission);
            }
        };
        for (var i = 0; i < matrix.length; i++) {
            _loop_1(i);
        }
        return data;
    };
    WfProcessViewTwoLevelComponent.constructViewportMap = function (data, viewport, customMetadata) {
        var viewportMap = new Map();
        var _loop_2 = function (firstClassifierId) {
            var _loop_3 = function (secondClassifierId) {
                var actionIds = Array.from(data.get(firstClassifierId).get(secondClassifierId).keys());
                var viewportModel = new idm_workflow_designer_1.WorkflowDesignerViewportModel();
                var viewportMetadata = viewport.getMetadata();
                viewportModel.viewMode = false;
                for (var i = viewport.process.actions.length - 1; i >= 0; i--) {
                    if (viewport.process.actions[i].id === 0 || actionIds.indexOf(viewport.process.actions[i].id) !== -1) {
                        viewportModel.process.actions.unshift(viewport.process.actions[i]);
                    }
                    else {
                        viewportMetadata['actions'].splice(i + 1, 1);
                    }
                }
                var _loop_4 = function (i) {
                    if (viewportModel.process.actions.some(function (action) { return action.begin.id === viewport.process.states[i].id || action.end.id === viewport.process.states[i].id; })) {
                        viewportModel.process.states.unshift(viewport.process.states[i]);
                    }
                    else {
                        viewportMetadata['states'].splice(i, 1);
                    }
                };
                for (var i = viewport.process.states.length - 1; i >= 0; i--) {
                    _loop_4(i);
                }
                var foundMetadata = customMetadata
                    .find(function (metadata) { return metadata.firstClassifierId === firstClassifierId && metadata.secondClassifierId === secondClassifierId; });
                viewportMetadata = foundMetadata ? foundMetadata.metadata : viewportMetadata;
                viewportModel.setMetadata(viewportMetadata);
                if (!viewportMap.has(firstClassifierId)) {
                    viewportMap.set(firstClassifierId, new Map());
                }
                if (!viewportMap.get(firstClassifierId).has(secondClassifierId)) {
                    viewportMap.get(firstClassifierId).set(secondClassifierId, viewportModel);
                }
            };
            for (var _i = 0, _a = Array.from(data.get(firstClassifierId).keys()); _i < _a.length; _i++) {
                var secondClassifierId = _a[_i];
                _loop_3(secondClassifierId);
            }
        };
        for (var _i = 0, _a = Array.from(data.keys()); _i < _a.length; _i++) {
            var firstClassifierId = _a[_i];
            _loop_2(firstClassifierId);
        }
        return viewportMap;
    };
    WfProcessViewTwoLevelComponent.preparePermissionByConditionMap = function (map, firstClassifierId, secondClassifierId, actionId) {
        if (!map.has(firstClassifierId)) {
            map.set(firstClassifierId, new Map());
        }
        if (!map.get(firstClassifierId).has(secondClassifierId)) {
            map.get(firstClassifierId).set(secondClassifierId, new Map());
        }
        if (!map.get(firstClassifierId).get(secondClassifierId).has(actionId)) {
            map.get(firstClassifierId).get(secondClassifierId).set(actionId, new Map());
        }
    };
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "secondClassifiers", {
        get: function () {
            return this._secondClassifiers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "selectedFirstClassifierTabIndex", {
        get: function () {
            return this._selectedFirstClassifierTabIndex;
        },
        set: function (value) {
            this._selectedFirstClassifierTabIndex = value;
            this._selectedSecondClassifierTabIndex = 0;
            this._selectedActionId = undefined;
            this._selectedActionRoles = [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "viewports", {
        get: function () {
            return this._viewports;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "customizedLayoutsMetadata", {
        get: function () {
            return this._customizedLayoutsMetadata;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "notification", {
        get: function () {
            return this._notification;
        },
        set: function (value) {
            this._notification = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "selectedActionId", {
        get: function () {
            return this._selectedActionId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "selectedActionRoles", {
        get: function () {
            return this._selectedActionRoles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "selectedFirstClassifierId", {
        get: function () {
            return this._selectedFirstClassifierId;
        },
        set: function (value) {
            this._selectedFirstClassifierId = value;
            this.resetHideActions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "selectedSecondClassifierId", {
        get: function () {
            return this._selectedSecondClassifierId;
        },
        set: function (value) {
            this._selectedSecondClassifierId = value;
            this.resetHideActions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessViewTwoLevelComponent.prototype, "stateValues", {
        get: function () {
            return this._stateValues;
        },
        enumerable: true,
        configurable: true
    });
    var WfProcessViewTwoLevelComponent_1;
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WfProcessViewTwoLevelComponent.prototype, "firstClassifierLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WfProcessViewTwoLevelComponent.prototype, "secondClassifierField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WfProcessViewTwoLevelComponent.prototype, "secondClassifierLabel", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], WfProcessViewTwoLevelComponent.prototype, "close", void 0);
    WfProcessViewTwoLevelComponent = WfProcessViewTwoLevelComponent_1 = __decorate([
        core_1.Component({
            selector: 'ejustice-wf-process-view-two-level',
            styles: [require('./wf-process-view-two-level.component.css')],
            template: require('./wf-process-view-two-level.component.html'),
            providers: [wf_permissions_helper_service_1.WfPermissionsHelperService]
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_workflow_service_client_js_1.ProcessService,
            idm_kb_service_client_js_1.KbService,
            wf_permissions_helper_service_1.WfPermissionsHelperService])
    ], WfProcessViewTwoLevelComponent);
    return WfProcessViewTwoLevelComponent;
}(workflow_base_control_component_1.WorkflowBaseControlComponent));
exports.WfProcessViewTwoLevelComponent = WfProcessViewTwoLevelComponent;
//# sourceMappingURL=wf-process-view-two-level.component.js.map